﻿import React, { useState, useEffect } from 'react';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import VeilederInntektskalkulatorDto from '../Models/VeilederInntektskalkulatorDto';
import contentResolver, { resolveRawText } from '../../Shared/Scripts/Utilities/EpiContentResolver';
import { connect } from 'react-redux';
import * as ValgTypes from '../Store/Valg/Types';
import { ArticleContentComponent } from '../../Shared/Scripts/Components/ArticleContentComponent';
import { ModalCompontent } from '../../Shared/Scripts/Components/ModalComponent';
import * as Ids from '../Models/Ids';
import { VeilederInntektskalkulatorAppState } from '../Store';
import { ResultatValg } from '../Store/Resultat/Types';
import { Satser } from '../Utilities/SatserApi';
import * as Utregninger from '../Utilities/Utregninger';
import { updateLiveMessage } from '../../Shared/Scripts/Utilities/LiveMessage';

interface BoksOwnProps {
    valg: ValgTypes.ValgState;
    locale: string;
    valuta?: string | null;
    resultat?: ResultatValg | null;
    satser: Satser | null;
}

type BoksAProps = BoksOwnProps & MapStateToProps & {};

const BoksBComponent = (props: BoksAProps): JSX.Element => {
    const { epiContext } = props;
    const [studererFulltid, setStudererFulltid] = useState(false);
    const [mottarBarnestipend, setMottarBarnestipend] = useState(false);
    const [stotteHeltAar, setStotteHeltAar] = useState(false);
    const [visModal, setVisModal] = useState(false);

    useEffect(() => {
        settDefaultInnstillinger();
        updateLiveMessage();
    }, []);

    function settDefaultInnstillinger(): void {

        if (props.satser == null) return;

        const inntekt: number = parseInt(props.valg.inntekt.value);

        //visning 1
        if (inntekt < props.satser.SATS_ST04_INNTEKTSGRENSE_DAGER_211_X) {
            setStudererFulltid(true);
            setMottarBarnestipend(false);
            setStotteHeltAar(true);
        }

        //visning 3

        if (inntekt > props.satser.SATS_ST04_INNTEKTSGRENSE_DAGER_211_X) {
            setStudererFulltid(true);
            setMottarBarnestipend(false);
            setStotteHeltAar(true);
        }
    }

    function hentSvar3(inntekt: number): JSX.Element | null {

        const belop: Utregninger.ReturnValues = Utregninger.RegnUtVisning3(
            inntekt,
            props.satser.SATS_ST04_INNTEKTSGRENSE_DAGER_211_X,
            props.satser.SATS_ST01_MAKS_BASISSTOTTE_DAG,
        );
        let text: string = resolveRawText(epiContext, 'boks2Svar3');
        text = text.replace(
            '[belop1]',
            '<div class="c-veileder__resultat-tekst c-veileder__panel-marginTop-killer c-veileder--tekst-aubergine">' +
                Utregninger.formatNumber(belop.belop1, props.locale) +
                ' <span class="c-veileder__tekst--postfix">' +
                props.valuta +
                '</span></div>',
        );
        text = text.replace('[belop2]', Utregninger.formatNumber(belop.belop2, props.locale));
        return <div className="c-veileder--tekst-svart" dangerouslySetInnerHTML={{ __html: text }} />;
    }

    function hentSvar4(inntekt: number): JSX.Element | null {

        const belop: Utregninger.ReturnValues = Utregninger.RegnUtVisning4(
            inntekt,
            props.satser.SATS_ST04_INNTEKTSGRENSE_DAGER_0_210,
            props.satser.SATS_ST01_MAKS_BASISSTOTTE_DAG,
        );
        let text: string = resolveRawText(epiContext, 'boks2Svar4');
        text = text.replace(
            '[belop3]',
            '<div class="c-veileder__resultat-tekst c-veileder__panel-marginTop-killer c-veileder--tekst-aubergine">' +
                Utregninger.formatNumber(belop.belop1, props.locale) +
                ' <span class="c-veileder__tekst--postfix">' +
                props.valuta +
                '</span></div>',
        );
        text = text.replace('[belop4]', Utregninger.formatNumber(belop.belop2, props.locale));
        return <div className="c-veileder--tekst-svart" dangerouslySetInnerHTML={{ __html: text }} />;
    }

    function hentSvar5(inntekt: number): JSX.Element | null {

        const belop: Utregninger.ReturnValues = Utregninger.RegnUtVisning5(
            inntekt,
            props.satser.SATS_ST04_INNTEKTSGRENSE_DAGER_211_X,
            props.satser.SATS_ST01_MAKS_BASISSTOTTE_DAG,
        );
        const text: string = resolveRawText(epiContext, 'boks2Svar5');
        let sp1: string = resolveRawText(epiContext, 'boks2Svar5_sp1');
        let sp2: string = resolveRawText(epiContext, 'boks2Svar5_sp2');
        let sp3: string = resolveRawText(epiContext, 'boks2Svar5_sp3');
        sp1 = sp1.replace('[belop5]', Utregninger.formatNumber(belop.belop1, props.locale));
        sp2 = sp2.replace('[belop6]', Utregninger.formatNumber(belop.belop2, props.locale));
        sp3 = sp3.replace('[belop7]', Utregninger.formatNumber(belop.belop3, props.locale));

        return (
            <div className="c-veileder--tekst-sized">
                <div className="c-veileder--overskrift-litt-margin c-veileder--tekst-svart">{text}</div>
                <div className="c-veileder--tekst-bold c-veileder--overskrift-litt-margin">{sp1}</div>
                <div className="c-veileder--tekst-bold c-veileder--overskrift-litt-margin">{sp2}</div>
                <div className="c-veileder--tekst-bold c-veileder--overskrift-litt-margin">{sp3}</div>
            </div>
        );
    }

    function hentSvar6(inntekt: number): JSX.Element | null {

        const belop: Utregninger.ReturnValues = Utregninger.RegnUtVisning6(
            inntekt,
            props.satser.SATS_ST04_INNTEKTSGRENSE_DAGER_0_210,
            props.satser.SATS_ST01_MAKS_BASISSTOTTE_DAG,
        );
        const text: string = resolveRawText(epiContext, 'boks2Svar6');
        let sp1: string = resolveRawText(epiContext, 'boks2Svar6_sp1');
        let sp2: string = resolveRawText(epiContext, 'boks2Svar6_sp2');
        let sp3: string = resolveRawText(epiContext, 'boks2Svar6_sp3');
        sp1 = sp1.replace('[belop8]', Utregninger.formatNumber(belop.belop1, props.locale));
        sp2 = sp2.replace('[belop9]', Utregninger.formatNumber(belop.belop2, props.locale));
        sp3 = sp3.replace('[belop10]', Utregninger.formatNumber(belop.belop3, props.locale));

        return (
            <div className="c-veileder--tekst-sized">
                <div className="c-veileder--overskrift-litt-margin c-veileder--tekst-svart">{text}</div>
                <div className="c-veileder--tekst-bold c-veileder--overskrift-litt-margin">{sp1}</div>
                <div className="c-veileder--tekst-bold c-veileder--overskrift-litt-margin">{sp2}</div>
                <div className="c-veileder--tekst-bold c-veileder--overskrift-litt-margin">{sp3}</div>
            </div>
        );
    }

    function hentSvar7(inntekt: number): JSX.Element | null {

        const belop: Utregninger.ReturnValues = Utregninger.RegnUtVisning7(
            inntekt,
            props.satser.SATS_ST04_INNTEKTSGRENSE_DAGER_211_X,
        );
        const text: string = resolveRawText(epiContext, 'boks2Svar7');
        let topplinje: string = resolveRawText(epiContext, 'boks2Svar7_topplinje');
        topplinje = topplinje.replace('[belop11]', Utregninger.formatNumber(belop.belop1, props.locale));

        return (
            <div className="c-veileder--tekst-sized">
                <div className="c-veileder--tekst-bold c-veileder--tekst-svart c-veileder--tekst-margin">
                    {topplinje}
                </div>
                <div className="c-veileder--tekst-svart">{text}</div>
            </div>
        );
    }

    function hentSvar8(inntekt: number): JSX.Element | null {

        const belop: Utregninger.ReturnValues = Utregninger.RegnUtVisning8(
            inntekt,
            props.satser.SATS_ST04_INNTEKTSGRENSE_DAGER_0_210,
        );
        const text: string = resolveRawText(epiContext, 'boks2Svar8');
        let topplinje: string = resolveRawText(epiContext, 'boks2Svar8_topplinje');
        topplinje = topplinje.replace('[belop12]', Utregninger.formatNumber(belop.belop1, props.locale));

        return (
            <div className="c-veileder--tekst-sized">
                <div className="c-veileder--tekst-bold c-veileder--tekst-svart c-veileder--tekst-margin">
                    {topplinje}
                </div>
                <div className="c-veileder--tekst-svart">{text}</div>
            </div>
        );
    }

    function hentSvar9(inntekt: number): JSX.Element | null {

        const belop: Utregninger.ReturnValues = Utregninger.RegnUtVisning9(
            inntekt,
            props.satser.SATS_ST04_INNTEKTSGRENSE_DAGER_211_X,
        );
        const text: string = resolveRawText(epiContext, 'boks2Svar9');
        let topplinje: string = resolveRawText(epiContext, 'boks2Svar9_topplinje');
        topplinje = topplinje.replace('[belop13]', Utregninger.formatNumber(belop.belop1, props.locale));

        return (
            <div className="c-veileder--tekst-sized">
                <div className="c-veileder--tekst-bold c-veileder--tekst-svart c-veileder--tekst-margin">
                    {topplinje}
                </div>
                <div className="c-veileder--tekst-svart">{text}</div>
            </div>
        );
    }

    function hentSvar10(inntekt: number): JSX.Element | null {

        const belop: Utregninger.ReturnValues = Utregninger.RegnUtVisning10(
            inntekt,
            props.satser.SATS_ST04_INNTEKTSGRENSE_DAGER_0_210,
        );
        const text: string = resolveRawText(epiContext, 'boks2Svar10');
        let topplinje: string = resolveRawText(epiContext, 'boks2Svar10_topplinje');
        topplinje = topplinje.replace('[belop14]', Utregninger.formatNumber(belop.belop1, props.locale));

        return (
            <div className="c-veileder--tekst-sized">
                <div className="c-veileder--tekst-bold c-veileder--tekst-svart c-veileder--tekst-margin">
                    {topplinje}
                </div>
                <div className="c-veileder--tekst-svart">{text}</div>
            </div>
        );
    }

    function hentVisning(): JSX.Element | null {
        //fjerner alle andre tegn enn tall, eks space og komma.

        const stringInntekt: string = props.valg.inntekt?.value.replace(/[^0-9]/g, '');
        const inntekt: number = parseInt(stringInntekt);

        //visning 1 - default visning
        if (inntekt <= props.satser.SATS_ST04_INNTEKTSGRENSE_DAGER_211_X && stotteHeltAar) {
            return (
                <div className="c-veileder--tekst-aubergine">
                    <h4 className="c-veileder__tittel--resultat">
                        {contentResolver(epiContext, 'boks2OverskriftUnderGrensen')}
                    </h4>
                    <div className="c-veileder--tekst-sized">
                        <div className="c-veileder--tekst-svart">{contentResolver(epiContext, 'boks2Svar1')}</div>
                        <div className="c-veileder__resultat-tekst-uthevet c-veileder__panel-marginTop-killer">
                            {contentResolver(epiContext, 'boks2Svar1Uthevet')}
                        </div>
                    </div>
                </div>
            );
        }

        //visning 2 - pÃ¥virkes av brukerens valg i innstillingene

        if (inntekt <= props.satser.SATS_ST04_INNTEKTSGRENSE_DAGER_0_210 && !stotteHeltAar) {
            return (
                <div className="c-veileder--tekst-aubergine">
                    <h4 className="c-veileder__tittel--resultat">
                        {contentResolver(epiContext, 'boks2OverskriftUnderGrensen')}
                    </h4>
                    <div className="c-veileder--tekst-sized">
                        <div className="c-veileder--tekst-svart">{contentResolver(epiContext, 'boks2Svar2')}</div>
                        <div className="c-veileder__resultat-tekst-uthevet c-veileder__panel-marginTop-killer">
                            {contentResolver(epiContext, 'boks2Svar2Uthevet')}
                        </div>
                    </div>
                </div>
            );
        }

        //visning 3 - default visning

        if (
            inntekt > props.satser.SATS_ST04_INNTEKTSGRENSE_DAGER_211_X &&
            studererFulltid &&
            !mottarBarnestipend &&
            stotteHeltAar
        ) {
            return (
                <div className="c-veileder--tekst-aubergine">
                    <h4 className="c-veileder__tittel--resultat">
                        {contentResolver(epiContext, 'boks2OverskriftOverGrensen')}
                    </h4>
                    <div className="c-veileder--tekst-sized">{hentSvar3(inntekt)}</div>
                </div>
            );
        }

        //visning 4 - pÃ¥virkes av brukerens valg i innstillingene

        if (
            inntekt > props.satser.SATS_ST04_INNTEKTSGRENSE_DAGER_0_210 &&
            studererFulltid &&
            !mottarBarnestipend &&
            !stotteHeltAar
        ) {
            return (
                <div className="c-veileder--tekst-aubergine">
                    <h4 className="c-veileder__tittel--resultat">
                        {contentResolver(epiContext, 'boks2OverskriftOverGrensen')}
                    </h4>
                    <div className="c-veileder--tekst-sized">{hentSvar4(inntekt)}</div>
                </div>
            );
        }

        //visning 5 - pÃ¥virkes av brukerens valg i innstillingene

        if (
            inntekt > props.satser.SATS_ST04_INNTEKTSGRENSE_DAGER_211_X &&
            !studererFulltid &&
            !mottarBarnestipend &&
            stotteHeltAar
        ) {
            return (
                <div className="c-veileder--tekst-aubergine">
                    <h4 className="c-veileder__tittel--resultat">
                        {contentResolver(epiContext, 'boks2OverskriftOverGrensen')}
                    </h4>
                    <div>{hentSvar5(inntekt)}</div>
                </div>
            );
        }

        //visning 6 - pÃ¥virkes av brukerens valg i innstillingene
        if (
            inntekt > props.satser.SATS_ST04_INNTEKTSGRENSE_DAGER_0_210 &&
            !studererFulltid &&
            !mottarBarnestipend &&
            !stotteHeltAar
        ) {
            return (
                <div className="c-veileder--tekst-aubergine">
                    <h4 className="c-veileder__tittel--resultat">
                        {contentResolver(epiContext, 'boks2OverskriftOverGrensen')}
                    </h4>
                    <div>{hentSvar6(inntekt)}</div>
                </div>
            );
        }

        //visning 7 - pÃ¥virkes av brukerens valg i innstillingene

        if (
            inntekt > props.satser.SATS_ST04_INNTEKTSGRENSE_DAGER_211_X &&
            studererFulltid &&
            mottarBarnestipend &&
            stotteHeltAar
        ) {
            return (
                <div className="c-veileder--tekst-aubergine">
                    <h4 className="c-veileder__tittel--resultat">
                        {contentResolver(epiContext, 'boks2OverskriftOverGrensen')}
                    </h4>
                    <div>{hentSvar7(inntekt)}</div>
                </div>
            );
        }

        //visning 8 - pÃ¥virkes av brukerens valg i innstillingene

        if (
            inntekt > props.satser.SATS_ST04_INNTEKTSGRENSE_DAGER_0_210 &&
            studererFulltid &&
            mottarBarnestipend &&
            !stotteHeltAar
        ) {
            return (
                <div className="c-veileder--tekst-aubergine">
                    <h4 className="c-veileder__tittel--resultat">
                        {contentResolver(epiContext, 'boks2OverskriftOverGrensen')}
                    </h4>
                    <div>{hentSvar8(inntekt)}</div>
                </div>
            );
        }

        //visning 9 - pÃ¥virkes av brukerens valg i innstillingene

        if (
            inntekt > props.satser.SATS_ST04_INNTEKTSGRENSE_DAGER_211_X &&
            !studererFulltid &&
            mottarBarnestipend &&
            stotteHeltAar
        ) {
            return (
                <div className="c-veileder--tekst-aubergine">
                    <h4 className="c-veileder__tittel--resultat">
                        {contentResolver(epiContext, 'boks2OverskriftOverGrensen')}
                    </h4>
                    <div>{hentSvar9(inntekt)}</div>
                </div>
            );
        }

        //visning 10 - pÃ¥virkes av brukerens valg i innstillingene
        if (
            inntekt > props.satser.SATS_ST04_INNTEKTSGRENSE_DAGER_0_210 &&
            !studererFulltid &&
            mottarBarnestipend &&
            !stotteHeltAar
        ) {
            return (
                <div className="c-veileder--tekst-aubergine">
                    <h4 className="c-veileder__tittel--resultat">
                        {contentResolver(epiContext, 'boks2OverskriftOverGrensen')}
                    </h4>
                    <div>{hentSvar10(inntekt)}</div>
                </div>
            );
        }
        return null;
    }

    return (
        <div
            id={Ids.boksB}
            className="c-veileder__panel c-veileder__panel-paddingBottom-killer c-veileder__panel--lilac"
        >
            <div className="c-veileder__panel-row">
                <div className="c-veileder__content">
                    <div className="c-veileder--tekstomraade">{hentVisning()}</div>
                </div>
                <div className="c-veileder__innstillinger">
                    <fieldset className="c-veileder__fieldset">
                        <legend>
                            <h5 className="c-veileder__innstillinger-overskrift c-veileder--overskrift-ekstra-liten">
                                {contentResolver(epiContext, 'innstillingOverskrift')}
                            </h5>
                        </legend>
                        <label className="c-checkbox-label">
                            {contentResolver(epiContext, 'innstillingStudererFulltid')}
                            <input
                                checked={studererFulltid}
                                onChange={(e) => setStudererFulltid(e.currentTarget.checked)}
                                type="checkbox"
                                className="c-checkbox-input"
                            />
                            <span className="c-checkbox-input-fake"></span>
                        </label>
                        <label className="c-checkbox-label">
                            {contentResolver(epiContext, 'innstillingStotteHeltAar')}
                            <input
                                checked={stotteHeltAar}
                                onChange={(e) => setStotteHeltAar(e.currentTarget.checked)}
                                type="checkbox"
                                className="c-checkbox-input"
                            />
                            <span className="c-checkbox-input-fake"></span>
                        </label>
                        <label className="c-checkbox-label">
                            {contentResolver(epiContext, 'innstillingBarnestipend')}
                            <input
                                checked={mottarBarnestipend}
                                onChange={(e) => setMottarBarnestipend(e.currentTarget.checked)}
                                type="checkbox"
                                className="c-checkbox-input"
                            />
                            <span className="c-checkbox-input-fake"></span>
                        </label>
                    </fieldset>
                </div>
                <div className="c-veileder__content">
                    <div className="c-veileder--tekstomraade">
                        <button
                            type="button"
                            className="c-knapp c-knapp--lenke c-knapp--lenke-aubergine c-veileder--div-spacer"
                            onClick={() => setVisModal(true)}
                        >
                            {contentResolver(epiContext, 'boks2ModalLenketekst')}
                        </button>
                        <ModalCompontent
                            isOpen={visModal}
                            onRequestClose={() => setVisModal(false)}
                            ariaCloseText={resolveRawText(epiContext, 'boks2ModalLukkTekst')}
                        >
                            <ArticleContentComponent
                                headerinnhold={contentResolver(epiContext, 'boks2ModalTittel')}
                                contentinnhold={contentResolver(epiContext, 'boks2ModalTekst')}
                            />
                        </ModalCompontent>
                    </div>
                </div>
            </div>
        </div>
    );
};

interface MapStateToProps {
    epiContext: EpiContext<VeilederInntektskalkulatorDto>;
}

export default connect(
    (state: VeilederInntektskalkulatorAppState): MapStateToProps => {
        return {
            epiContext: state.epiContext,
        };
    },
)(BoksBComponent);
